import { Action, createReducer, on } from '@ngrx/store';

import * as FavoriteOccupationsActions from './favorite-occupations.actions';
import * as FavoriteOccupationsFeatureState from './favorite-occupations.state';

const favoriteOccupationsReducer = createReducer(
  FavoriteOccupationsFeatureState.initialFavoriteOccupationsState,

  on(
    FavoriteOccupationsActions.favoriteOccupationsLoadedSuccess,
    (state, { favoriteOccupations }) => {
      // `setAll` throws "entities is not iterable" on a missing list.
      return FavoriteOccupationsFeatureState.favoriteOccupationsStateAdapter.setAll(
        favoriteOccupations ?? [],
        state
      );
    }
  ),

  on(
    FavoriteOccupationsActions.favoriteOccupationAddedSuccess,
    (state, { favoriteOccupation }) => {
      return FavoriteOccupationsFeatureState.favoriteOccupationsStateAdapter.addOne(
        favoriteOccupation,
        state
      );
    }
  ),

  on(
    FavoriteOccupationsActions.favoriteOccupationRemovedSuccess,
    (state, { onetCode, jobId }) => {
      return FavoriteOccupationsFeatureState.favoriteOccupationsStateAdapter.removeOne(
        onetCode + '_' + (jobId ?? 0),
        { ...state }
      );
    }
  )
);

export function reducer(
  state: FavoriteOccupationsFeatureState.FavoriteOccupationsState | undefined,
  action: Action
) {
  return favoriteOccupationsReducer(state, action);
}
